export default __webpack_public_path__ + "static/media/30.d62a49ab.jpg";